// @ts-check
import {
  useIsMutating,
  useMutation,
  useQueryClient
} from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { accountSelector } from '../../../../../RTK/account';
import { switchOrg } from '../../../../../common/clients/accounts.service';
import { QUERY_KEYS } from '../../../../../common/consts/queryKeys';
import { refreshAccessTokenAndStoreInCookie } from '../../../../../common/utils/cookieHandler/token';

export const useGetDashboardData = () => {
  const queryClient = useQueryClient();
  const account = useSelector(accountSelector);
  const isMutating = useIsMutating({ mutationKey: [QUERY_KEYS.DASHBOARD] });

  const handleOrgSelected = async orgDetails => {
    const newOrg = await switchOrg({
      organization_id: orgDetails.id,
      gitstream_account_id: orgDetails.gitstream_account_id
    });

    return newOrg;
  };

  const { mutate, isError } = useMutation(
    [QUERY_KEYS.DASHBOARD],
    handleOrgSelected,
    {
      onSuccess(data) {
        refreshAccessTokenAndStoreInCookie(data);
        queryClient.refetchQueries();
        queryClient.invalidateQueries();
        queryClient.getQueryCache().clear();
      }
    }
  );

  return {
    account,
    isError,
    isLoading: Boolean(isMutating),
    onOrgSelected: mutate
  };
};
